import React from 'react';
import SubscriberCard from 'components/common/election/cards/SubscriberCard';
import { Subscriber } from 'types/electionService';
import { toJS } from 'mobx';
import { observer } from 'mobx-react-lite';
import { useRootStore } from 'store/rootStore';
import { ProductLineId } from '@insurancemenu/imenu-components-lib/dist/types/ProductLineId';
import { useHistory } from 'react-router-dom';
import { getClassesAvailableForSelection } from 'global/services-helpers/electionService';
import { createSubscriberPresenter } from 'global/utils/election/electionPresenters';
import useSubscriberTaskUrlParams from 'global/hooks/useSubscriberTaskUrlParams';

export interface SubscriberElectionsProps {
  subscriber: Subscriber;
}
const SubscriberElections = observer(({ subscriber }: SubscriberElectionsProps): JSX.Element => {
  const {
    domainStoreV2: { availableClasses },
    reviewSubscriberStore: { products, employeeClasses, subscriberRates, cartId, requiredSubInfoPresenter },
    subscriberStore: { getLinkToPortfolioDetails },
  } = useRootStore();

  const history = useHistory();
  const { entityId: periodId } = useSubscriberTaskUrlParams();

  const convertedProducts = products?.map((product) => toJS(product)).slice();
  const convertedEeClasses = employeeClasses.map((eeClassInfo) => toJS(eeClassInfo)).slice();
  const convertedRates = subscriberRates?.map((rate) => toJS(rate)).slice();
  const convertedRequiredSubInfo = requiredSubInfoPresenter ? toJS(requiredSubInfoPresenter) : undefined;

  const onShowDetails = (productLineId: ProductLineId): void => {
    const link = getLinkToPortfolioDetails(subscriber, productLineId, convertedProducts, cartId, periodId);
    history.push(link);
  };

  return (
    <SubscriberCard
      subscriber={createSubscriberPresenter(subscriber)}
      isEditable={false}
      productLineRates={convertedRates}
      products={convertedProducts}
      subscriberClassesMap={{
        employeeClasses: getClassesAvailableForSelection(convertedEeClasses, availableClasses),
      }}
      callbacksMap={{
        onShowDetails,
      }}
      requiredSubInfo={convertedRequiredSubInfo}
    />
  );
});

export default SubscriberElections;
